import React from 'react';

interface SocialIconButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  href: string;
}

const SocialIconButton: React.FC<SocialIconButtonProps> = ({ children, href, className = '', ...props }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
      className={[
        'inline-flex h-6 w-6 items-center justify-center rounded-[8px] border border-white bg-transparent text-white',
        className,
      ].join(' ')}
    >
      {children}
    </a>
  );
};

export default SocialIconButton;
